import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ToggleOptionComponent } from 'app/shared/components/form-ui/toggle-option/toggle-option.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TripPurgeTypeEnum } from 'app/common/enums/trip-purge-type.enum';

@Component({
  selector: 'app-modal-purge-trip',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule,
    ReactiveFormsModule, 
    ToggleOptionComponent,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './modal-purge-trip.component.html',
})
export class PurgeTripDialogComponent {
  TripPurgeTypeEnum = TripPurgeTypeEnum;
  @ViewChild("customAlert") customAlert!: TemplateRef<any>;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PurgeTripDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { tripId: string },
  ){
    this.form = this.fb.group({
      partial: [true],
      total: [false]
    });
  }

  onSelectPurge(type: TripPurgeTypeEnum): void {
    const partial = this.form.get('partial')?.value;
    const total = this.form.get('total')?.value;

    if (type === TripPurgeTypeEnum.PARTIAL) {
      if (partial) {
        this.form.patchValue({ total: false });
      }
    } else {
      if (total) {
        this.form.patchValue({ partial: false });
      }
    }
  }

  get isSomeOptionSelected(): boolean {
    return this.form.get('partial')?.value || this.form.get('total')?.value;
  }

  get purgeType(): TripPurgeTypeEnum | null {
    if (this.form.get('partial')?.value) return TripPurgeTypeEnum.PARTIAL;
    if (this.form.get('total')?.value) return TripPurgeTypeEnum.TOTAL;
    return null;
  }
  
  openCustomDialog(): void {
    this.dialog
      .open(this.customAlert, { data: null, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.onSubmit());
  }

  onSubmit() {
    if (this.isSomeOptionSelected) {
      const result = {
        purgeType: this.purgeType
      };

      this.dialogRef.close(result);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
